import commonMixin from '@/mixin/common'
import {getVcode, reset} from '@/api/server/auth'
import {removeAll, removeItem} from '@/utils/storage'
import Tabbar from '@/components/Tabbar'

export default {
  name: 'resetPage',
  mixins: [commonMixin],
  data () {
    return {
        phone: null,
        vcode: null,
        password: null,
        password_confirm: null,
        loadingVcode: false,
        counter: 0
    }
  },
  components: {
    Tabbar
  },
  computed: {
    vcodeStatus () {
      return  this.counter > 0
    },
    vcodeTips () {
        return this.counter > 0 ? `${this.counter} s` : '发送'
    }
  },
  methods: {
    onSubmit () {
        let code = this.vcode
        let password = this.password
        let phone = this.phone
        if (!phone || !this.isPhone(phone)) {
            this.error('请正确填写手机号码')
            return false
        }
        if (!code) {
            this.error('请正确填写验证码')
            return false
        }
        if (!password || (password.length < 6 || password.length > 16)) {
            this.error('请正确填写密码,6-16位字符')
            return false
        }
        let query = {
            phone: phone,
            password: password,
            code: code
        }
        reset(query).then( (res) => {
            if (res.code === 200) {
                this.success('密码修改成功')
                removeItem('userinfo')
                removeAll()
                this.$router.push({name: 'login'})

            } else {
                this.warning(res.message, 'bottom')
            }
        })
    },
    getCode () {
        if (!this.phone || !this.isPhone(this.phone)) {
            this.error('请正确填写手机号码')
            return false
        }
        this.loadingVcode = true
        let query = {
            phone: this.phone,
        }
        getVcode(query).then(res => {
            this.loadingVcode = false
            if (res.code === 200) {
            this.countDown(60)
            } else {
            this.warning(res.message, 'bottom')
            }
        }).catch(err => {
            console.log(err)
            this.loadingVcode = false
        })
    },
    countDown (count) {
        this.counter = count - 1
        if (this.counter > 0) {
            setTimeout(() => {
                this.countDown(this.counter)
            }, 1000)
        } else {
            // resend
        }
    },
    reset () {
      this.phone = null
      this.vcode = null
      this.password = null
      this.loadingVcode = false
      this.counter = 0
    },
    handleRoute (route) {
      if (route.name === 'reset') {
        this.reset()
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}